import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=73ac7b04&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=73ac7b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ac7b04",
  null
  
)

export default component.exports